import React, { useRef, useEffect, useMemo, useCallback } from "react";
import Section from "../sections/Section";
import arePropsEqual from "../../utils/arePropsEqual";

const ElementConditionalRow = (props) => {
  let element = props.element;
  const classes = style.classes(element, props.builder, props.device);

  const conditional_row_items = useMemo(() => {
    return Object.values(element.content_toggle_items)
      .filter(row => row.element_id == element.id && row.toBeDeleted !== true)
      .sort((a, b) => a.position - b.position);
  }, [element.content_toggle_items, element.id]);

  const visibleRow = useMemo(() => {
    return conditional_row_items.find(
      (r) => r?.id == element.options["editor-visible-toggle-id"]
    ) || conditional_row_items[0];
  }, [conditional_row_items, element.options["editor-visible-toggle-id"]]);

  const sectionsByToggleItemId = useMemo(() => {
    const sectionsMap = new Map();
    Object.values(element.sections).forEach(section => {
      if (section.step_id === props.section.step_id) {
        sectionsMap.set(section.content_toggle_item_id, section);
      }
    });
    return sectionsMap;
  }, [element.sections, props.section.step_id]);

  const elementRef = useRef(null);

  useEffect(() => {
    if (props.builder == false) {
      const matchedRowDiv = elementRef.current.querySelector(
        `.cf-conditional-row-section-box[data-conditional-row-id="${visibleRow.id}"]`
      );

      if (matchedRowDiv) {
        matchedRowDiv.style.display = "block";
      }
    }
  });

  const renderToggleItem = useCallback((toggleItem, show = true) => {
    const toggleSection = sectionsByToggleItemId.get(toggleItem?.id);

    if (toggleSection) {
      return (
        <div
          id={`cf-conditional-row-${toggleItem.id}-section-${toggleSection.id}`}
          key={`cf-conditional-row-${toggleItem.id}-section-${toggleSection.id}`}
          className="cf-conditional-row-section-box"
          data-conditional-row-element-id={element.id}
          data-conditional-row-id={toggleItem.id}
          style={{ display: show ? "block" : "none" }}
        >
          <Section
            website={props.website}
            cta={props.cta}
            variant={props.variant}
            builder={props.builder}
            preview={props.preview}
            step={props.step}
            section={toggleSection}
            device={props.device}
          />
        </div>
      );
    }
    return null;
  }, [sectionsByToggleItemId]);

  const renderedItems = useMemo(() => {
    if (props.builder === true) {
      return renderToggleItem(visibleRow);
    } else {
      return conditional_row_items.map((row_item) =>
        renderToggleItem(row_item, false)
      );
    }
  }, [props.builder, visibleRow, conditional_row_items, renderToggleItem]);

  return (
    <React.Fragment>
      <div ref={elementRef} className={classes} data-element-id={element.id}>
        {renderedItems}
      </div>
    </React.Fragment>
  );
};

const style = {
  classes: (element, builder, device) => {
    let options = element.options;
    let classes = "element-content cf-conditional-row-element ";
    let alignmentClass = "cf-outer-center";

    if (device == "mobile") {
      if (options["cf-alignment-mobile"]) {
        if (options["cf-alignment-mobile"].indexOf("left") > -1) {
          alignmentClass = "cf-outer-left";
        } else if (options["cf-alignment-mobile"].indexOf("center") > -1) {
          alignmentClass = "cf-outer-center";
        } else if (options["cf-alignment-mobile"].indexOf("right") > -1) {
          alignmentClass = "cf-outer-right";
        }
      }
    } else {
      if (options["cf-alignment"]) {
        if (options["cf-alignment"].indexOf("left") > -1) {
          alignmentClass = "cf-outer-left";
        } else if (options["cf-alignment"].indexOf("center") > -1) {
          alignmentClass = "cf-outer-center";
        } else if (options["cf-alignment"].indexOf("right") > -1) {
          alignmentClass = "cf-outer-right";
        }
      }
    }

    classes += " " + alignmentClass;

    return classes;
  },
};

export default React.memo(ElementConditionalRow, arePropsEqual);
